import { useEffect } from 'react';
import { useUpdateWhenScheduleAdvances } from '../../data/hooks/datetimeHooks';
import { useOnce } from '../../data/hooks/onceHooks';
import { useUpcomingSessions } from '../../data/hooks/schedule/useUpcomingSessions';
import { useProgramSession } from '../../data/hooks/schedule/useProgramSession';
import { useIsAppMinimized } from '../../data/hooks/ui/useIsAppMinimized';
import { useVirtualRoom } from '../../data/hooks/ui/useVirtualRoom';
import { useExternalURL } from '../../data/hooks/ui/useExternalURL';
import { openExternalURL } from '../../misc/openLinks';

// NOTE: this can stay here for now but if it needs to be used elsewhere of have more complex behaviors, it should go into the store
const AUTOOPEN_ONCE_COLLECTION = 'AUTO_OPENED_SESSIONS';

const AutoOpenVirtualRoom = (props) => {
    const { eventId, currentSession } = props,
        previouslyOpenedSessions = useOnce(AUTOOPEN_ONCE_COLLECTION),
        externalURL = useExternalURL(),
        virtualRoom = useVirtualRoom(),
        isAppMinimized = useIsAppMinimized(),
        virtualRoomSession = useProgramSession(eventId, virtualRoom?.programId)

    useUpdateWhenScheduleAdvances(eventId);

    // TODO: add forced update at beginning of each program/meeting session

    useEffect(() => {
        // auto open virtual room
        if (
            (currentSession?.session_content_auto_open ||
                currentSession?.session_content_url ==
                    virtualRoomSession?.session_content_url) &&
            (!externalURL ||
                currentSession?.session_content_url ==
                    virtualRoomSession?.session_content_url) &&
            currentSession?.session_content_url &&
            !previouslyOpenedSessions.find((id) => id == currentSession.id)
        ) {
            app.store.dispatch(
                app.actions.once.touch(
                    AUTOOPEN_ONCE_COLLECTION,
                    currentSession.id
                )
            );
            app.store.dispatch(
                app.actions.collect.event(
                    'auto-open',
                    eventId,
                    'program.session_content_url',
                    currentSession.id,
                    currentSession.session_content_url_target,
                    'auto-open'
                )
            );
            openExternalURL({
                eventId,
                url: currentSession.session_content_url,
                programId: currentSession.id,
                target: currentSession.session_content_url_target,
                maximize: externalURL ? !isAppMinimized : true,
            });
        }
    }, [currentSession, externalURL]);

    return null;
};

export default AutoOpenVirtualRoom;
